import { loadStripe } from '@stripe/stripe-js';

// Determine if we're in production or development
const isProduction = process.env.NODE_ENV === 'production';

// Use appropriate keys based on environment
const stripePublishableKey = isProduction 
  ? (process.env.REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY || 'pk_live_your_live_publishable_key_here')
  : (process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY || 'pk_test_your_test_publishable_key_here');

export const stripePromise = loadStripe(stripePublishableKey);

// Define the plan interface
interface SubscriptionPlan {
  id: string;
  name: string;
  price: number;
  interval: string;
  features: readonly string[];
  savings?: string;
}

// Get price IDs from environment variables based on current mode
const getPriceId = (planType: 'monthly' | 'yearly') => {
  const mode = isProduction ? 'live' : 'test';
  const envVar = mode === 'test' 
    ? (planType === 'monthly' ? 'REACT_APP_STRIPE_MONTHLY_PRICE_ID_TEST' : 'REACT_APP_STRIPE_YEARLY_PRICE_ID_TEST')
    : (planType === 'monthly' ? 'REACT_APP_STRIPE_MONTHLY_PRICE_ID_LIVE' : 'REACT_APP_STRIPE_YEARLY_PRICE_ID_LIVE');
  
  const priceId = process.env[envVar];
  
  if (!priceId) {
    console.warn(`⚠️  Missing ${envVar} environment variable for ${mode} mode`);
    return `price_${mode}_${planType}_placeholder`;
  }
  
  console.log(`🔧 Using ${mode} mode price ID for ${planType} plan: ${priceId}`);
  return priceId;
};

// Subscription plans configuration
export const subscriptionPlans: Record<string, SubscriptionPlan> = {
  monthly: {
    id: getPriceId('monthly'),
    name: 'Monthly Plan',
    price: 20.00,
    interval: 'month',
    features: [
      'Unlimited access to all analytics'
    ]
  },
  yearly: {
    id: getPriceId('yearly'),
    name: 'Yearly Plan',
    price: 100.00,
    interval: 'year',
    features: [
      'Unlimited access to all analytics'
    ],
    savings: undefined
  }
} as const;

export type PlanType = keyof typeof subscriptionPlans;

// Export current mode for debugging
export const currentMode = isProduction ? 'live' : 'test'; 